/* STYRKR FUEL TOOL — WIZARD + RESULT RENDERER
   Mounts on .ft-app, renders all screens, drives state machine.
   Reads from window.STYRKR_FUEL_V7_DATA. */

   (function (window, document) {
    'use strict';
  
    var DATA = window.STYRKR_FUEL_V7_DATA;
    if (!DATA) { console.error('[fuel-tool] data layer not loaded'); return; }
  
    /* ─────────────────────────────────────────────
       STATE
    ───────────────────────────────────────────── */
    var state = {
      mode: null,                 // 'race' | 'training' | 'quick'
      sport: null,                // discipline key
      sessionType: null,
      eventName: '',
      eventDate: '',
      durationMin: 240,
      intensity: null,
      weightKg: 75,
      weightUnit: 'kg',
      heightCm: null,            // V7-18: athlete details — capture-only (segmentation), not in calc yet
      age: null,                 // V7-18: athlete details — capture-only (segmentation), not in calc yet
      caffeine: null,
      products: ['MIX60', 'GEL50', 'GEL30', 'BAR50', 'SLT_PLUS'],   // V7-20: product picker (was `weighting`). Balanced default = prior behaviour.
      gutTier: null,
      refineOpen: false,
      sweatRateMlH: null,
      sodiumTier: 'average',
      ftpW: null,
      thresholdPaceMinKm: null,
      goal: null,
      dietary: 'standard',
      environment: 'mild',        // SCI-P0-3: cool|mild|warm|hot — sweat scaling input
      flavour: 'berry',
      firstName: '',
      email: '',
      sex: '',                    // V4-13: capture-only segmentation field — '' | 'female' | 'male' | 'unspecified'
      consent: false,            // UK GDPR / PECR — explicit opt-in only, never pre-ticked
      currentScreen: 'welcome',
      plan: null
    };
  
    // Note: 'refine' is NOT a separate screen — it's a panel inside 'gut'. Don't add it here.
    var SCREENS = ['welcome', 'sport', 'session', 'duration', 'intensity', 'weight', 'caffeine', 'products', 'gut', 'gate', 'result'];
  
    /* ─────────────────────────────────────────────
       SESSION PERSISTENCE
       Saves user inputs to sessionStorage so the wizard survives back-button
       navigation within the same tab (e.g. leaving to read about the
       Performance Lab and returning). Clears on tab close — sessionStorage,
       not localStorage, by design: avoids stale data on shared devices and
       dodges the "you have a saved plan" confirmation UX entirely.
  
       What we save: inputs + currentScreen.
       What we don't: `email`/`consent` (privacy + double-tracking), `plan`
       (cheap to regenerate from inputs; saving risks staleness if DATA changes).
    ───────────────────────────────────────────── */
    var STORAGE_KEY = 'styrkr.fuelTool.v1';
    // Whitelist of state keys we persist. Anything not in here is ignored on
    // both save and restore. Bump the version in STORAGE_KEY if this list
    // changes in a breaking way.
    var PERSIST_KEYS = [
      'mode', 'sport', 'sessionType',
      'durationMin', 'intensity', 'weightKg', 'weightUnit', 'heightCm', 'age',
      'caffeine', 'products', 'gutTier', 'refineOpen',
      'sweatRateMlH', 'sodiumTier', 'ftpW', 'thresholdPaceMinKm',
      'goal', 'dietary', 'environment', 'flavour', 'firstName',
      'sex',                     // V4-13: persist sex selection across back-nav within the same tab
      'currentScreen'
    ];
  
    function persistState() {
      try {
        if (typeof sessionStorage === 'undefined') return;
        var payload = {};
        for (var i = 0; i < PERSIST_KEYS.length; i++) {
          var k = PERSIST_KEYS[i];
          payload[k] = state[k];
        }
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {
        // Quota exceeded, blocked storage, or private mode on old Safari.
        // Silent — persistence is a nice-to-have, never a blocker.
      }
    }
  
    function restoreState() {
      try {
        if (typeof sessionStorage === 'undefined') return;
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var payload = JSON.parse(raw);
        if (!payload || typeof payload !== 'object') return;
        // Only merge whitelisted keys — guards against tampered storage.
        for (var i = 0; i < PERSIST_KEYS.length; i++) {
          var k = PERSIST_KEYS[i];
          if (Object.prototype.hasOwnProperty.call(payload, k) && payload[k] !== undefined) {
            state[k] = payload[k];
          }
        }
        // If the user was last on the result screen, the plan isn't persisted
        // (intentional — see comment above). Regenerate it from the restored
        // inputs so the screen has something to render. If generation fails
        // (e.g. partial inputs), fall back to the gut screen so they can fix it.
        if (state.currentScreen === 'result') {
          try {
            var DATA = window.STYRKR_FUEL_V7_DATA;
            if (DATA && typeof DATA.generatePlan === 'function') {
              state.plan = DATA.generatePlan(buildPlanInput());
            }
            if (!state.plan) state.currentScreen = 'gut';
          } catch (err) {
            state.currentScreen = 'gut';
            state.plan = null;
          }
        }
      } catch (e) {
        // Corrupted payload — discard, start fresh.
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
      }
    }
  
    /* ─────────────────────────────────────────────
       HELPERS
    ───────────────────────────────────────────── */
    function el(id) { return document.getElementById(id); }
    function qs(sel, root) { return (root || document).querySelector(sel); }
    function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  
    function fmt(n) { return Math.round(n).toLocaleString('en-GB'); }
    function money(n) { return '£' + n.toFixed(2); }

    function brandAccent() {
      var root = qs('.ftv7-app');
      if (root) {
        var scoped = getComputedStyle(root).getPropertyValue('--ft-accent').trim();
        if (scoped) return scoped;
      }
      var global = getComputedStyle(document.documentElement).getPropertyValue('--styrkr-green').trim();
      return global || '#4dcdc6';
    }
  
    function trackKlaviyo(eventName, props) {
      try {
        if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['track', eventName, props || {}]);
        }
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['track', eventName, props || {}]);
        }
      } catch (e) { /* swallow */ }
    }
  
    function identifyKlaviyo(profile) {
      try {
        if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['identify', profile]);
        }
      } catch (e) { /* swallow */ }
    }
  
    /* ─────────────────────────────────────────────
       KLAVIYO PAYLOAD BUILDER (data-capture layer)
       Splits the captured plan into:
         • identity  — durable PROFILE properties used to BUILD SEGMENTS
                       (sport, goal, physiology, event date, recommended SKUs…).
         • planEvent — a rich "Plan Generated" EVENT used to TRIGGER FLOWS
                       (plan-abandonment, race-week countdown) and carry the full
                       bundle so a flow can re-send the athlete's own plan + cart.
       Every fuel_tool_* key is namespaced so segment-building in Klaviyo is clean.
    ───────────────────────────────────────────── */
    function buildKlaviyoPayloads(input, plan) {
      var t = plan.targets;
      var tot = plan.totals;
      var disc = (DATA.DISCIPLINES[input.sport] || {}).label || input.sport;
  
      // Bundle → structured SKU list + replenishment cadence.
      var bundleSkus = plan.bundle.map(function (b) {
        return {
          sku: b.product.key,
          title: b.product.shortTitle,
          variant_id: b.product.variantId,
          qty: b.unitsNeeded,
          boxes: b.boxes,
          price: b.product.price,
          line_total: b.lineTotal,
          sessions_covered: b.sessionsCovered
        };
      });
      // Replenishment clock = the limiting product (fewest sessions covered).
      var sessionsPerBundle = plan.bundle.length
        ? Math.min.apply(null, plan.bundle.map(function (b) { return b.sessionsCovered; }))
        : 0;
      var recommendedSkus = plan.bundle.map(function (b) { return b.product.shortTitle; }).join(', ');
  
      // ── PROFILE (durable, segmentable) ──
      var identity = {
        $email: state.email,
        $first_name: state.firstName,
        // Core segmentation axes
        fuel_tool_sport: input.sport,
        fuel_tool_discipline: disc,
        fuel_tool_gut_tier: input.gutTier,
        fuel_tool_caffeine: input.caffeine,
        fuel_tool_products: (input.products || []).join(', '),
        fuel_tool_goal: input.goal,
        fuel_tool_intensity: input.intensity,
        fuel_tool_dietary: input.dietary,
        fuel_tool_environment: input.environment,
        // Physiology
        fuel_tool_weight_kg: input.weightKg,
        fuel_tool_height_cm: Number(state.heightCm) || null,   // V7-18: capture-only segmentation
        fuel_tool_age: Number(state.age) || null,              // V7-18: capture-only segmentation
        fuel_tool_sweat_rate_mlh: t.sweatRate,
        fuel_tool_sodium_tier: input.sodiumTier,
        fuel_tool_typical_duration_min: input.durationMin,
        // Latest plan snapshot (powers personalised re-marketing)
        fuel_tool_last_carb_target: t.carbsGH,
        fuel_tool_last_fluid_target: t.fluidMlH,
        fuel_tool_last_sodium_target: t.sodiumMgH,
        fuel_tool_recommended_skus: recommendedSkus,
        fuel_tool_last_bundle_value: plan.bundleTotal,
        fuel_tool_sessions_per_bundle: sessionsPerBundle,
        fuel_tool_last_plan_id: plan.planId,
        fuel_tool_last_plan_at: new Date().toISOString(),
        // Marketing consent — flows gate sends on this (UK GDPR / PECR)
        fuel_tool_consent: !!state.consent
      };
      // Sex — only when volunteered (V4-13 logic preserved).
      if (state.sex === 'female' || state.sex === 'male') {
        identity.$gender = state.sex === 'female' ? 'F' : 'M';
        identity.fuel_tool_sex = state.sex;
      } else if (state.sex === 'unspecified') {
        identity.fuel_tool_sex = 'unspecified';
      }
  
      // ── EVENT (transactional, flow trigger) ──
      var planEvent = {
        plan_id: plan.planId,
        // Context
        sport: input.sport,
        discipline: disc,
        duration_min: input.durationMin,
        intensity: input.intensity,
        goal: input.goal,
        environment: input.environment,
        gut_tier: input.gutTier,
        caffeine_pref: input.caffeine,
        // The plan
        carb_target_gh: t.carbsGH,
        fluid_target_mlh: t.fluidMlH,
        sodium_target_mgh: t.sodiumMgH,
        caffeine_total_mg: tot.caffeineMg,
        // The bundle (so a flow can re-send the exact cart)
        bundle_total: plan.bundleTotal,
        bundle_item_count: plan.bundle.length,
        bundle_skus: bundleSkus,
        recommended_skus: recommendedSkus,
        sessions_per_bundle: sessionsPerBundle,
        // Klaviyo revenue convention
        $value: plan.bundleTotal
      };
  
      return { identity: identity, planEvent: planEvent };
    }
  
    /* ─────────────────────────────────────────────
       SCREEN RENDERERS
    ───────────────────────────────────────────── */
    function renderWelcome() {
      return '' +
        '<section class="ft-screen is-active" data-screen="welcome">' +
          '<div class="ft-hero">' +
            '<div>' +
              '<div class="ft-eyebrow">The Fuel Tool</div>' +
              '<h1 class="ft-display" style="margin-top:16px">FUEL<br>SMARTER<span class="ft-display-dot" aria-hidden="true">.</span></h1>' +
            '</div>' +
            '<p class="ft-hero-sub">Build a science-backed, per-session fueling plan in under 3 minutes. Used by athletes from sprint-distance to 200-mile ultras.</p>' +
          '</div>' +
          '<div class="ft-mode-grid ft-mode-grid--2">' +
            modeCard('01', 'race',  'RACE PLAN',     'Got an event? Build a race-day timeline.', '~3 min', true) +
            modeCard('02', 'quick', 'QUICK SESSION', 'Just tomorrow\u2019s ride or run.',         '~2 min') +
          '</div>' +
        '</section>';
    }
    function modeCard(num, mode, title, desc, time, recommended) {
      return '<button class="ft-mode-card' + (recommended ? ' is-recommended' : '') + '" data-mode="' + mode + '">' +
        '<div class="ft-mode-card-head">' +
          '<div class="ft-mode-num">' + num + '</div>' +
          (recommended ? '<div class="ft-mode-tag">RECOMMENDED</div>' : '') +
        '</div>' +
        '<div>' +
          '<div class="ft-mode-title">' + title + '</div>' +
          '<div class="ft-mode-desc">' + desc + '</div>' +
        '</div>' +
        '<div class="ft-mode-meta"><span>' + time + '</span><span class="ft-mode-arrow">\u2192</span></div>' +
      '</button>';
    }
  
    function renderSport() {
      var disciplines = DATA.DISCIPLINES;
      // Cluster by category so related disciplines sit together
      var clusters = [
        { tag: 'RUN',  items: [
          { k: 'road_run',  label: 'Road' },
          { k: 'trail_run', label: 'Trail' },
          { k: 'ultra',     label: 'Ultra' }
        ]},
        { tag: 'BIKE', items: [
          { k: 'road_cycle',  label: 'Road' },
          { k: 'offroad_cyc', label: 'Off-road / MTB' }
        ]},
        { tag: 'TRI',  items: [
          { k: 'triathlon', label: 'Multi-sport' }
        ]}
      ];
      function clusterHtml(c) {
        return '<div class="ft-sport-cluster" data-cluster="' + c.tag.toLowerCase() + '">' +
          '<div class="ft-sport-cluster-head">' + c.tag + '</div>' +
          '<div class="ft-sport-cluster-body">' +
            c.items.map(function (it) {
              return '<button class="ft-opt ft-opt--sport" data-q="sport" data-val="' + it.k + '">' +
                '<div class="ft-opt-num">' + c.tag + '</div>' +
                '<div class="ft-opt-label">' + it.label + '</div>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>';
      }
      return '' +
        '<section class="ft-screen is-active" data-screen="sport">' +
          '<div class="ft-q">' +
            '<h2 class="ft-h1 ft-q-title">What\u2019s your sport?</h2>' +
            '<p class="ft-q-help">Pick the discipline that matches your session. Each tunes carb, fluid, and sodium targets differently.</p>' +
            '<div class="ft-sport-clusters">' +
              clusters.map(clusterHtml).join('') +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    function renderSession() {
      var labelByMode = {
        race: { title: 'What\u2019s the event?', help: 'Pick the option that matches your race day.' },
        training: { title: 'What kind of week?', help: 'We\u2019ll calibrate volume across 7 days.' },
        quick: { title: 'What\u2019s tomorrow\u2019s session?', help: 'One session, just enough plan to nail it.' }
      };
      var l = labelByMode[state.mode] || labelByMode.quick;
      var sessionOpts = state.mode === 'race'
        ? [
            { k: 'race_day',   v: 'Race day',           d: 'Full race-day fueling timeline + pre-load notes.' },
            { k: 'race_prep',  v: 'Race prep session',  d: 'Dial in fueling before the event.' }
          ]
        : state.mode === 'training'
          ? [
              { k: 'build',    v: 'Build week',     d: 'High volume, normal carb intake.' },
              { k: 'recovery', v: 'Recovery week',  d: 'Lower volume, easy-paced.' },
              { k: 'peak',     v: 'Peak / taper',   d: 'Sharp sessions, fully fueled.' }
            ]
          : [
              { k: 'long',    v: 'Long session',          d: 'Endurance pace, 2h+ typically.' },
              { k: 'quality', v: 'Quality / intervals',   d: 'Hard efforts, threshold or above.' },
              { k: 'easy',    v: 'Easy session',          d: 'Aerobic, conversational pace.' }
            ];
  
      return '' +
        '<section class="ft-screen is-active" data-screen="session">' +
          '<div class="ft-q">' +
            '<h2 class="ft-h1 ft-q-title">' + l.title + '</h2>' +
            '<p class="ft-q-help">' + l.help + '</p>' +
            '<div class="ft-options ft-options-' + sessionOpts.length + '">' +
              sessionOpts.map(function (o, i) {
                return '<button class="ft-opt" data-q="sessionType" data-val="' + o.k + '">' +
                  '<div class="ft-opt-num">0' + (i + 1) + '</div>' +
                  '<div class="ft-opt-label">' + o.v + '</div>' +
                  '<div class="ft-opt-desc">' + o.d + '</div>' +
                '</button>';
              }).join('') +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
    // V7-16: event name + date inputs removed per Jake. The race-week trigger that
    // relied on fuel_tool_event_date is therefore no longer fed from the tool.
  
    function renderDuration() {
      var hrs = Math.floor(state.durationMin / 60);
      var mins = state.durationMin % 60;
      return '' +
        '<section class="ft-screen is-active" data-screen="duration">' +
          '<div class="ft-q">' +          '<h2 class="ft-h1 ft-q-title">How long is the session?</h2>' +
            '<p class="ft-q-help">Slide to set duration. We\u2019ll plan fueling across the whole effort.</p>' +
            '<div class="ft-slider-wrap">' +
              '<div class="ft-slider-readout" id="ft-dur-readout">' + hrs + '<span style="font-size:0.5em;color:var(--ft-mute);font-weight:400">h</span> ' + (mins < 10 ? '0' + mins : mins) + '<span style="font-size:0.5em;color:var(--ft-mute);font-weight:400">m</span></div>' +
              '<div class="ft-slider-unit">total duration</div>' +
              '<input type="range" min="30" max="720" step="15" value="' + state.durationMin + '" class="ft-slider" id="ft-dur-slider" style="--ft-fill:' + (((state.durationMin - 30) / (720 - 30)) * 100) + '%"  />' +
              '<div class="ft-slider-marks">' +
                // V7-17: marks were evenly spaced (flex) but the slider maps 30–720min,
                // so the "3h" label sat at 25% (≈3:30) instead of its true 21.7%. Each
                // mark is now absolutely positioned at its real value-percentage so the
                // label, the thumb, and the readout all agree.
                [[30,'30m'],[180,'3h'],[360,'6h'],[540,'9h'],[720,'12h']].map(function (m) {
                  var pct = ((m[0] - 30) / (720 - 30)) * 100;
                  return '<span class="ft-slider-mark" style="left:' + pct + '%">' + m[1] + '</span>';
                }).join('') +
              '</div>' +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    function renderIntensity() {
      var ints = DATA.INTENSITY;
      return '' +
        '<section class="ft-screen is-active" data-screen="intensity">' +
          '<div class="ft-q">' +          '<h2 class="ft-h1 ft-q-title">What intensity?</h2>' +
            '<p class="ft-q-help">No FTP or threshold pace required at this layer \u2014 you can refine later.</p>' +
            '<div class="ft-options ft-options-4">' +
              Object.keys(ints).map(function (k) {
                return '<button class="ft-opt" data-q="intensity" data-val="' + k + '">' +
                  '<div class="ft-opt-label">' + ints[k].label + '</div>' +
                  '<div class="ft-opt-stat">~' + ints[k].effortPct + '% threshold</div>' +
                '</button>';
              }).join('') +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    function renderWeight() {
      return '' +
        '<section class="ft-screen is-active" data-screen="weight">' +
          '<div class="ft-q">' +
            '<h2 class="ft-h1 ft-q-title">Athlete details</h2>' +
            '<p class="ft-q-help">Body weight scales your carb, fluid and sodium targets. Height and age sharpen future recommendations.</p>' +
            '<div class="ft-athlete-fields">' +
              // ── Body weight (drives the calc) — stepper + unit toggle ──
              '<div class="ft-field">' +
                '<label class="ft-field-label" for="ft-weight-input">Body weight</label>' +
                '<div class="ft-num-input">' +
                  '<button class="ft-num-step" data-step="-1" aria-label="Decrease weight">−</button>' +
                  '<input type="number" id="ft-weight-input" inputmode="numeric" pattern="[0-9]*" value="' + state.weightKg + '" min="40" max="140" step="1" aria-label="Body weight" />' +
                  '<span class="ft-num-unit-toggle" role="group" aria-label="Weight unit">' +
                    '<button class="' + (state.weightUnit === 'kg' ? 'is-active' : '') + '" data-unit="kg" aria-pressed="' + (state.weightUnit === 'kg') + '">KG</button>' +
                    '<button class="' + (state.weightUnit === 'lb' ? 'is-active' : '') + '" data-unit="lb" aria-pressed="' + (state.weightUnit === 'lb') + '">LB</button>' +
                  '</span>' +
                  '<button class="ft-num-step" data-step="1" aria-label="Increase weight">+</button>' +
                '</div>' +
              '</div>' +
              // ── Height + age (capture-only for now) — compact paired row ──
              '<div class="ft-field-pair">' +
                '<div class="ft-field">' +
                  '<label class="ft-field-label" for="ft-height-input">Height</label>' +
                  '<div class="ft-num-mini">' +
                    '<input type="number" id="ft-height-input" data-bind="heightCm" inputmode="numeric" pattern="[0-9]*" value="' + (state.heightCm || '') + '" min="120" max="220" step="1" placeholder="175" aria-label="Height in centimetres" />' +
                    '<span class="ft-num-mini-unit">cm</span>' +
                  '</div>' +
                '</div>' +
                '<div class="ft-field">' +
                  '<label class="ft-field-label" for="ft-age-input">Age</label>' +
                  '<div class="ft-num-mini">' +
                    '<input type="number" id="ft-age-input" data-bind="age" inputmode="numeric" pattern="[0-9]*" value="' + (state.age || '') + '" min="14" max="90" step="1" placeholder="35" aria-label="Age in years" />' +
                    '<span class="ft-num-mini-unit">yrs</span>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    function renderCaffeine() {
      var opts = [
        { k: 'yes',  l: 'Yes \u2014 full caf', d: 'Caffeinated GEL30 + MIX across the session' },
        { k: 'half', l: 'Half and half',      d: 'Alternating Caf and non-Caf gels' },
        { k: 'no',   l: 'No caf',             d: 'Non-caf gels (GEL50 + GEL30) and non-caf drinks' }
      ];
      return '' +
        '<section class="ft-screen is-active" data-screen="caffeine">' +
          '<div class="ft-q">' +          '<h2 class="ft-h1 ft-q-title">Caffeine preference?</h2>' +
            '<p class="ft-q-help">ISSN suggests 3\u20136 mg/kg for performance. We\u2019ll cap dose accordingly.</p>' +
            '<div class="ft-options ft-options-3">' +
              opts.map(function (o) {
                return '<button class="ft-opt" data-q="caffeine" data-val="' + o.k + '">' +
                  '<div class="ft-opt-label">' + o.l + '</div>' +
                  '<div class="ft-opt-desc">' + o.d + '</div>' +
                '</button>';
              }).join('') +
            '</div>' +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    // V7-26: product picker grouped into BARS / MIXES / GELS / ELECTROLYTES.
    // Athlete toggles products; the generator allocates WITHIN the selected
    // categories by fit (carb-dense option first, lighter option when the hour's
    // gut-ceiling headroom is tight). Card tags show the retail pack — the tool
    // only ever sells 12-boxes for bars/gels/mix sachets, the SLT05 box of 6,
    // the SLT+ 30-sachet box, and the MIX+ 555g tub (no 6-packs / BYOB singles).
    function renderProducts() {
      var P = DATA.PRODUCTS || {};
      function oos(p) { return !!(p && p.available === false); }
      var cats = [
        { title: 'Bars', items: [
          { k: 'BAR50', name: 'BAR50', tag: 'Box of 12', d: 'Solid rice bar · 50g carb', oos: oos(P.BAR50_VARIETY) },
          { k: 'BAR30', name: 'BAR30', tag: 'Box of 12', d: 'Lighter rice bar · 30g carb', oos: oos(P.BAR30) }
        ] },
        { title: 'Mixes', items: [
          { k: 'MIX60',    name: 'MIX60', tag: 'Box of 12', d: 'Dual-carb drink · 60g', oos: oos(P.MIX60) },
          { k: 'MIX90',    name: 'MIX90', tag: 'Box of 12', d: 'High-carb drink · 90g', oos: oos(P.MIX90) },
          { k: 'MIX_PLUS', name: 'MIX+',  tag: '555g tub',  d: '30g carb + 360mg sodium', oos: oos(P.MIX_PLUS) }
        ] },
        { title: 'Gels', items: [
          { k: 'GEL50', name: 'GEL50', tag: 'Box of 12', d: 'Dual-carb gel · 50g carb · no caffeine', oos: oos(P.GEL50_BERRY) },
          { k: 'GEL30', name: 'GEL30', tag: 'Box of 12', d: 'Lighter gel · 30g · caf or non-caf', oos: oos(P.GEL30_CAF) && oos(P.GEL30_NONCAF) }
        ] },
        { title: 'Electrolytes', items: [
          { k: 'SLT_PLUS', name: 'SLT+',  tag: '30-sachet box', d: 'Sachet · 1000mg sodium', oos: oos(P.SLT_PLUS) },
          { k: 'SLT07',    name: 'SLT07', tag: 'Tube of 12',    d: 'Tablets · 1000mg sodium', oos: oos(P.SLT07) },
          { k: 'SLT05',    name: 'SLT05', tag: 'Box of 6',      d: 'Quad-blend · 360mg sodium', oos: oos(P.SLT05) }
        ] }
      ];
      var selected = state.products || [];
      return '' +
        '<section class="ft-screen is-active" data-screen="products">' +
          '<div class="ft-q">' +
            '<h2 class="ft-h1 ft-q-title">Which products do you want?</h2>' +
            '<p class="ft-q-help">Tap to toggle. We’ll build the plan from your selected categories — carb-dense products lead, lighter ones fill the gaps.</p>' +
            cats.map(function (cat) {
              return '<div class="ft-product-cat">' +
                '<div class="ft-product-cat-title">' + cat.title + '</div>' +
                '<div class="ft-product-grid' + (cat.items.length === 3 ? ' ft-product-grid--3' : '') + '">' +
                  cat.items.map(function (f) {
                    var isOn = selected.indexOf(f.k) !== -1 && !f.oos;
                    return '<button class="ft-product-opt' + (isOn ? ' is-selected' : '') + (f.oos ? ' is-oos' : '') + '"' +
                      ' data-product="' + f.k + '" role="checkbox" aria-checked="' + (isOn ? 'true' : 'false') + '"' +
                      (f.oos ? ' disabled aria-disabled="true"' : '') + '>' +
                      '<span class="ft-product-check" aria-hidden="true"></span>' +
                      '<span class="ft-product-tag">' + f.tag + (f.oos ? ' · out of stock' : '') + '</span>' +
                      '<span class="ft-product-name">' + f.name + '</span>' +
                      '<span class="ft-product-desc">' + f.d + '</span>' +
                    '</button>';
                  }).join('') +
                '</div>' +
              '</div>';
            }).join('') +
          '</div>' +
          navButtons() +
        '</section>';
    }
  
    function renderGut() {
      var tiers = DATA.GUT_TIERS;
      var gutCopy = {
        'new':         { headline: 'Still building',         sub: 'Cramps or sloshing if I push past one gel an hour.' },
        'experienced': { headline: 'Comfortable fueling',    sub: 'Multi-hour sessions with regular fuel feel fine.' },
        'trained':     { headline: 'High-carb trained',      sub: 'I’ve practised race-pace fueling and tolerate it.' }
      };
      return '' +
        '<section class="ft-screen is-active" data-screen="gut">' +
          '<div class="ft-q">' +
            '<h2 class="ft-h1 ft-q-title">How trained is your gut?</h2>' +
            '<p class="ft-q-help">High-rate carb intake is a trainable adaptation. Pick the line that sounds most like you — we’ll cap carbs at a safe ceiling for that level.</p>' +
            '<div class="ft-options ft-options-3 ft-options--gut">' +
              Object.keys(tiers).map(function (k) {
                var copy = gutCopy[k] || { headline: tiers[k].label, sub: '' };
                return '<button class="ft-opt ft-opt--gut" data-q="gutTier" data-val="' + k + '">' +
                  '<div class="ft-opt-label">' + copy.headline + '</div>' +
                  '<div class="ft-opt-desc">' + copy.sub + '</div>' +
                  // V7-21: ceiling figure made explicit + prominent (60 / 90 / 120 g/h)
                  '<div class="ft-opt-ceiling">' +
                    '<span class="ft-ceiling-num">' + tiers[k].target + '</span>' +
                    '<span class="ft-ceiling-unit">g/h carb<br>ceiling</span>' +
                  '</div>' +
                '</button>';
              }).join('') +
            '</div>' +
            '<div class="ft-refine-zone">' +
              '<button class="ft-refine-toggle' + (state.refineOpen ? ' is-open' : '') + '"' +
                ' data-action="toggle-refine" aria-expanded="' + (state.refineOpen ? 'true' : 'false') + '"' +
                ' aria-controls="ft-refine">' +
                '<span class="ft-refine-toggle-text">' +
                  '<span class="ft-refine-toggle-label">' + (state.refineOpen ? 'Hide refinements' : 'Tap to refine your plan') + '</span>' +
                  '<span class="ft-refine-toggle-sub">Sweat rate, FTP, goal, dietary — dial it in for a sharper plan</span>' +
                '</span>' +
                '<span class="ft-refine-toggle-chevron" aria-hidden="true"></span>' +
              '</button>' +
              '<div class="ft-refine-panel' + (state.refineOpen ? ' is-open' : '') + '" id="ft-refine">' +
                refineContent() +
              '</div>' +
            '</div>' +
          '</div>' +
          navButtons(true) +
        '</section>';
    }
    function refineContent() {
      var sodTiers = DATA.SODIUM_TIERS;
      return [
        /* SCI-P0-3: Environment picker \u2014 single biggest missing input per audit.
           Heat doubles sweat rate (Sawka 2007). User picks the climate band. */
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">Environment</div><div class="ft-refine-help">Sweat rate scales with heat. Pick the conditions you\u2019ll race in.</div></div>' +
          '<div class="ft-options ft-options-4 ft-options--tight">' +
            [
              { k:'cool', l:'Cool',      sub:'< 15\u00b0C' },
              { k:'mild', l:'Mild',      sub:'15\u201322\u00b0C' },
              { k:'warm', l:'Warm',      sub:'22\u201328\u00b0C' },
              { k:'hot',  l:'Hot/humid', sub:'> 28\u00b0C' }
            ].map(function (e) {
              return '<button class="ft-opt ft-opt--compact" data-q="environment" data-val="' + e.k + '">' +
                '<div class="ft-opt-label">' + e.l + '</div>' +
                '<div class="ft-opt-stat">' + e.sub + '</div>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>',
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">Sweat rate</div><div class="ft-refine-help">ml per hour. Don\u2019t know? Tap below.</div></div>' +
          '<div>' +
            '<input type="number" inputmode="numeric" class="ft-refine-input" data-bind="sweatRateMlH" placeholder="e.g. 900" />' +
            '<button class="ft-btn-link ft-btn-link--gap" data-action="open-perf-lab">I don\u2019t know \u2192</button>' +
          '</div>' +
        '</div>',
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">Sweat sodium</div><div class="ft-refine-help">Salt residue on skin / clothes after training.</div></div>' +
          '<div class="ft-options ft-options-4 ft-options--tight">' +
            Object.keys(sodTiers).map(function (k) {
              return '<button class="ft-opt ft-opt--compact" data-q="sodiumTier" data-val="' + k + '"><div class="ft-opt-label">' + sodTiers[k].label + '</div></button>';
            }).join('') +
          '</div>' +
        '</div>',
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">FTP / Threshold pace</div><div class="ft-refine-help">Cyclists: FTP in watts. Runners: threshold pace in min/km.</div></div>' +
          '<div class="ft-refine-pair">' +
            '<div><label class="ft-eyebrow">FTP (W)</label><br><input type="number" inputmode="numeric" class="ft-refine-input ft-refine-input--narrow" data-bind="ftpW" placeholder="250" /></div>' +
            '<div><label class="ft-eyebrow">Pace (min/km)</label><br><input type="text" class="ft-refine-input ft-refine-input--narrow" data-bind="thresholdPaceMinKm" placeholder="4:15" /></div>' +
          '</div>' +
        '</div>',
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">Goal</div></div>' +
          '<div class="ft-options ft-options-4 ft-options--tight">' +
            [
              { k:'finish', l:'Finish',              tip:'Just complete the event safely. Conservative carb targets, generous hydration.' },
              { k:'pb',     l:'PB',                  tip:'Beat your best time. Aggressive but defensible carb intake at gut tier ceiling.' },
              { k:'podium', l:'Podium',              tip:'All-out race execution. Top-of-tier carbs and full caffeine load.' },
              { k:'adapt',  l:'Training adaptation', tip:'Build metabolic flexibility. Lower carb intake to stress fat-burning systems.' }
            ].map(function (g) {
              return '<button class="ft-opt ft-opt--compact" data-q="goal" data-val="' + g.k + '">' +
                '<div class="ft-opt-label ft-opt-label--info">' +
                  g.l +
                  '<span class="ft-info" tabindex="0" role="button" aria-label="' + g.tip.replace(/"/g, '&quot;') + '" data-tip="' + g.tip.replace(/"/g, '&quot;') + '">i</span>' +
                '</div>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>',
        '<div class="ft-refine-row">' +
          '<div><div class="ft-refine-label">Dietary</div></div>' +
          '<div class="ft-options ft-options-3 ft-options--tight">' +
            ['standard:Standard', 'vegan:Vegan'].map(function (s) {
              var p = s.split(':');
              return '<button class="ft-opt ft-opt--compact" data-q="dietary" data-val="' + p[0] + '"><div class="ft-opt-label">' + p[1] + '</div></button>';
            }).join('') +
          '</div>' +
        '</div>'
      ].join('');
    }
  
    function renderGate() {
      // P0-1: pull REAL targets from the just-generated plan, not hardcoded placeholders.
      // P0-2: build a session-context phrase so the gate headline references what the
      // athlete actually answered — increases perceived personalisation at the moment of capture.
      var p = state.plan;
      var targets = (p && p.targets) ? p.targets : { carbsGH: 90, fluidMlH: 750, sodiumMgH: 450 };
      var sessionPhrase = 'session';
      if (p && p.input) {
        var durMin = p.input.durationMin;
        var hrs = (durMin / 60).toFixed(durMin % 60 === 0 ? 0 : 1);
        var sportLabel = (DATA.DISCIPLINES[p.input.sport] || {}).label || 'session';
        var intLabel   = (DATA.INTENSITY[p.input.intensity] || {}).label || '';
        sessionPhrase = hrs + 'h ' + sportLabel + (intLabel ? ' · ' + intLabel : '');
      }
      return '' +
        '<section class="ft-screen is-active" data-screen="gate">' +
          '<div class="ft-gate">' +
            '<div class="ft-eyebrow">Plan built</div>' +
            '<h2 class="ft-h1" style="margin-top:12px">You just built a plan for your<br><span class="ft-accent-text">' + sessionPhrase + '</span>.</h2>' +
            '<p class="ft-q-help" style="margin:16px auto 0">Where should we send it? We’ll email the full timeline, share-card PNG and your bundle.</p>' +
            /* P1-8: Trust strip — three VERIFIED claims, no fabricated testimony:
                 1. 10 sources — SOURCES table in fuel-tool-v3-data.js has exactly 10 numbered refs (1-10)
                 2. 30min–12h range — duration slider min=30 max=720 (line 293 in this file)
                 3. Performance Lab — real STYRKR testing programme per CLAUDE.md brand context */
            '<div class="ft-gate-trust" role="note" aria-label="Why trust this plan">' +
              '<div class="ft-gate-trust-row">' +
                '<div class="ft-gate-trust-item">' +
                  '<div class="ft-gate-trust-num">10</div>' +
                  '<div class="ft-gate-trust-lbl">peer-reviewed sources behind every number — cited inline.</div>' +
                '</div>' +
                '<div class="ft-gate-trust-item">' +
                  '<div class="ft-gate-trust-num">6</div>' +
                  '<div class="ft-gate-trust-lbl">disciplines tuned individually — road, trail, ultra, MTB, road bike, tri.</div>' +
                '</div>' +
                '<div class="ft-gate-trust-item">' +
                  '<div class="ft-gate-trust-num">Lab</div>' +
                  '<div class="ft-gate-trust-lbl">built on protocols from STYRKR’s Performance Lab — not a generic calculator.</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="ft-gate-card">' +
              '<div class="ft-gate-snippet" aria-hidden="true">' +
                '<div class="ft-gate-tile">' +
                  '<div class="ft-gate-tile-value"><span class="ft-gate-stat">' + targets.carbsGH + '</span></div>' +
                  '<div class="ft-gate-tile-label">g/h carbs</div>' +
                '</div>' +
                '<div class="ft-gate-tile">' +
                  '<div class="ft-gate-tile-value"><span class="ft-gate-stat">' + targets.fluidMlH + '</span></div>' +
                  '<div class="ft-gate-tile-label">ml/h fluid</div>' +
                '</div>' +
                '<div class="ft-gate-tile">' +
                  '<div class="ft-gate-tile-value"><span class="ft-gate-stat">' + targets.sodiumMgH + '</span></div>' +
                  '<div class="ft-gate-tile-label">mg/h sodium</div>' +
                '</div>' +
              '</div>' +
              '<div class="ft-form-row">' +
                '<label for="ft-first-name">First name</label>' +
                '<input id="ft-first-name" type="text" data-bind="firstName" placeholder="Jake" autocomplete="given-name" />' +
              '</div>' +
              '<div class="ft-form-row">' +
                '<label for="ft-email">Email</label>' +
                '<input id="ft-email" type="email" data-bind="email" placeholder="you@example.com" autocomplete="email" aria-describedby="ft-email-error" />' +
                '<span id="ft-email-error" class="ft-form-error" role="alert" aria-live="polite"></span>' +
              '</div>' +
              /* V4-13: optional sex field — capture-only, NOT used in plan calc.
                 Three pill buttons, no selection by default so opting out is the
                 path of least resistance. Sent to Klaviyo for segmentation. */
              '<div class="ft-form-row ft-form-row--sex">' +
                '<label id="ft-sex-label">Helps us personalise (optional)</label>' +
                '<div class="ft-sex-toggle" role="radiogroup" aria-labelledby="ft-sex-label">' +
                  '<button type="button" class="ft-sex-opt' + (state.sex === 'female' ? ' is-active' : '') + '" data-sex="female" role="radio" aria-checked="' + (state.sex === 'female') + '">Female</button>' +
                  '<button type="button" class="ft-sex-opt' + (state.sex === 'male' ? ' is-active' : '') + '" data-sex="male" role="radio" aria-checked="' + (state.sex === 'male') + '">Male</button>' +
                  '<button type="button" class="ft-sex-opt' + (state.sex === 'unspecified' ? ' is-active' : '') + '" data-sex="unspecified" role="radio" aria-checked="' + (state.sex === 'unspecified') + '">Prefer not to say</button>' +
                '</div>' +
              '</div>' +
              '<label class="ft-checkbox"><input type="checkbox" data-bind="consent" /> Send me race-week tips and product updates</label>' +
              '<button class="ft-btn ft-btn-primary" id="ft-reveal" style="width:100%;justify-content:center;padding:16px">Reveal my plan \u2192</button>' +
              '<p class="ft-fineprint">No spam. Unsubscribe anytime. UK GDPR compliant.</p>' +
            '</div>' +
          '</div>' +
        '</section>';
    }
  
    function renderResult() {
      var p = state.plan;
      if (!p) {
        return '' +
          '<section class="ft-screen is-active" data-screen="result">' +
            '<div class="ft-error-state" role="alert">' +
              '<div class="ft-eyebrow">SOMETHING BROKE</div>' +
              '<h2 class="ft-h1" style="margin-top:12px">We couldn’t build your plan.</h2>' +
              '<p class="ft-q-help">An error fired while generating your fueling plan. Your inputs are safe — try again, or go back and adjust.</p>' +
              '<div class="ft-error-actions">' +
                '<button class="ft-btn ft-btn-primary" data-action="retry-plan">Try again →</button>' +
                '<button class="ft-btn ft-btn-ghost" data-action="back-to-gut">← Adjust inputs</button>' +
              '</div>' +
            '</div>' +
          '</section>';
      }
  
      var summary = (p.input.durationMin / 60).toFixed(p.input.durationMin % 60 === 0 ? 0 : 1) + 'h ' +
                     (DATA.DISCIPLINES[p.input.sport] || {}).label + ' \u00b7 ' +
                     (DATA.INTENSITY[p.input.intensity] || {}).label + ' \u00b7 ' +
                     p.input.weightKg + 'kg \u00b7 ' +
                     (p.input.caffeine === 'half' ? 'half-caf' : p.input.caffeine === 'yes' ? 'full-caf' : 'no caf');
  
      return '' +
        '<section class="ft-screen is-active" data-screen="result" aria-labelledby="ft-result-heading">' +
          '<h1 id="ft-result-heading" class="ft-sr-only">Your STYRKR fueling plan</h1>' +
          '<div class="ft-result">' +
            /* Block 1 — timeline (lead with the most useful, most visual block) */
            '<div class="ft-block ft-block-B">' +
              '<div class="ft-eyebrow">01 \u00b7 Race-day timeline</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">' + p.events.length + ' fueling moments across ' + (p.input.durationMin / 60).toFixed(1) + ' hours.</h3>' +
              renderTimeline(p) +
              /* SCI-P1-8: per-event nutrient table — printable, spot-checkable.
                 Previously the per-event detail was only in the timeline tooltips.
                 Table is collapsed by default (won't dominate the visual) but full
                 table is what an athlete prints + clips to a bento box. */
              '<details class="ft-event-table-wrap">' +
                '<summary class="ft-event-table-toggle">View full event table \u2014 time, product, nutrients per fuel</summary>' +
                '<div class="ft-event-table-scroll">' +
                  '<table class="ft-event-table">' +
                    '<thead><tr>' +
                      '<th>Time</th><th>Product</th>' +
                      '<th class="ft-num">Carbs</th><th class="ft-num">Fluid</th>' +
                      '<th class="ft-num">Sodium</th><th class="ft-num">Caffeine</th>' +
                    '</tr></thead>' +
                    '<tbody>' +
                      p.events.map(function (ev) {
                        var t = ev.timeMin;
                        var neg = t < 0;
                        var abs = Math.abs(t);
                        var hh = Math.floor(abs / 60);
                        var mm = abs % 60;
                        var timeStr = (neg ? '\u2212' : '') + hh + ':' + (mm < 10 ? '0' + mm : mm);
                        return '<tr>' +
                          '<td class="ft-event-time">' + timeStr + '</td>' +
                          '<td class="ft-event-product">' + ev.product.shortTitle + '</td>' +
                          '<td class="ft-num">' + (ev.carbs > 0 ? '+' + ev.carbs + 'g' : '\u2014') + '</td>' +
                          '<td class="ft-num">' + (ev.fluid > 0 ? '+' + ev.fluid + 'ml' : '\u2014') + '</td>' +
                          '<td class="ft-num">' + (ev.sodium > 0 ? '+' + ev.sodium + 'mg' : '\u2014') + '</td>' +
                          '<td class="ft-num">' + (ev.caffeine > 0 ? '+' + ev.caffeine + 'mg' : '\u2014') + '</td>' +
                        '</tr>';
                      }).join('') +
                    '</tbody>' +
                    '<tfoot><tr>' +
                      '<td colspan="2" class="ft-event-total-label">Plan totals</td>' +
                      '<td class="ft-num">' + p.totals.carbsG + 'g</td>' +
                      '<td class="ft-num">' + p.totals.fluidMl + 'ml</td>' +
                      '<td class="ft-num">' + p.totals.sodiumMg + 'mg</td>' +
                      '<td class="ft-num">' + p.totals.caffeineMg + 'mg</td>' +
                    '</tr></tfoot>' +
                  '</table>' +
                '</div>' +
              '</details>' +
              '<div class="ft-timeline-actions">' +
                '<button class="ft-btn ft-btn-ghost" data-png="card">\u2193 Race-day card (PNG)</button>' +
                '<button class="ft-btn ft-btn-ghost" data-png="story">\u2193 Instagram story (PNG)</button>' +
                '<button class="ft-btn ft-btn-ghost" id="ft-pdf-btn">\u2193 Print / save as PDF</button>' +
              '</div>' +
            '</div>' +
  
            /* Block 2 — targets (stat island, demoted under the timeline) */
            '<div class="ft-block ft-block-A">' +
              '<div class="ft-eyebrow">02 \u00b7 Your targets</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">Hourly numbers to hit.</h3>' +
              '<h2 class="ft-sr-only">Targets</h2>' +
              '<div class="ft-targets" style="margin-top:12px">' +
                targetCell(p.targets.carbsGH, 'g/h', 'carbs', '[1] [2]') +
                targetCell(p.targets.fluidMlH, 'ml/h', 'fluid', '[4]') +
                targetCell(p.targets.sodiumMgH, 'mg/h', 'sodium', '[5] [10]') +
              '</div>' +
              '<div class="ft-summary-line">For your ' + summary + ' \u00b7 Plan ' + p.planId + ' \u00b7 ' + new Date().toLocaleDateString('en-GB') + '</div>' +
            '</div>' +
  
            /* Block C — bundle */
            '<div class="ft-block ft-block-light ft-block-C">' +
              '<div class="ft-eyebrow">03 \u00b7 Your box</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">Full retail packs, ready to ship.</h3>' +
              '<div class="ft-bundle-list">' +
                p.bundle.map(function (b, idx) {
                  return '<div class="ft-bundle-item">' +
                    '<div class="ft-bundle-num">0' + (idx + 1) + '</div>' +
                    '<div>' +
                      '<div class="ft-bundle-title">' + b.product.title + '</div>' +
                      '<div class="ft-bundle-meta">' + b.product.packLabel + ' \u00b7 covers ~' + b.sessionsCovered + ' sessions</div>' +
                    '</div>' +
                    '<div class="ft-bundle-price">' + (b.boxes > 1 ? b.boxes + '\u00d7 ' : '') + money(b.lineTotal) + '</div>' +
                  '</div>';
                }).join('') +
              '</div>' +
              '<div class="ft-bundle-total">' +
                '<span class="ft-bundle-total-label">Subtotal</span>' +
                '<span class="ft-bundle-total-num">' + money(p.bundleTotal) + '</span>' +
              '</div>' +
              '<button class="ft-btn ft-btn-primary ft-bundle-cta" id="ft-cart-btn">Add box to cart \u2192</button>' +
              '<span id="ft-cart-status" class="ft-form-error" role="status" aria-live="polite"></span>' +
            '</div>' +
  
            /* Block D — reasoning */
            '<div class="ft-block ft-block-D">' +
              '<div class="ft-eyebrow">04 \u00b7 Why this plan</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">The science behind every number.</h3>' +
              '<div class="ft-reasons">' +
                p.reasoning.map(function (r) {
                  return '<div class="ft-reason">' +
                    '<div class="ft-reason-num">0' + r.n + '</div>' +
                    '<div class="ft-reason-claim">' + r.claim +
                      '<span class="ft-reason-cite">' + r.cites.map(function (c) { return '[' + c + ']'; }).join(' ') + '</span>' +
                    '</div>' +
                  '</div>';
                }).join('') +
              '</div>' +
            '</div>' +
  
            /* Charts block \u2014 primary always visible, secondary collapsed under expander */
            '<div class="ft-block ft-block-charts">' +
              '<div class="ft-eyebrow">05 \u00b7 The numbers in motion</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">Carb balance + hydration.</h3>' +
              '<p class="ft-mute" style="margin-top:8px;font-size:13px;max-width:60ch">Two headline curves up top. Open the expander for the full physiology stack \u2014 glycogen, caffeine, bonk risk, anaerobic reserve, fluid + sodium balance.</p>' +
              '<div class="ft-charts-grid ft-charts-grid--primary">' +
                chartCard('cumCarbs', 'Carb balance', 'intake vs oxidised \u00b7 markers show each fueling moment',
                  'Carb balance chart: ' + p.totals.carbsG + ' grams total intake versus oxidised carbohydrate over ' + (p.input.durationMin / 60).toFixed(1) + ' hours.',
                  carbBalanceKey()) +
                chartCard('hydration', 'Hydration status', '% body mass loss \u00b7 2% line = performance, 4% = health risk',
                  'Hydration loss expressed as percent of starting body mass. Sweat plus respiratory loss minus fluid intake. ACSM 2007 thresholds shown.') +
              '</div>' +
              '<details class="ft-charts-more" id="ft-charts-more">' +
                '<summary class="ft-charts-more-summary">' +
                  '<span class="ft-charts-more-label">Tap to see full physiology</span>' +
                  '<span class="ft-charts-more-sub">Glycogen, caffeine, bonk risk' + (p.meta && p.meta.isCyclistish ? ', anaerobic reserve' : '') + ', fluid + sodium \u2014 the full stack</span>' +
                  '<span class="ft-charts-more-icon" aria-hidden="true"></span>' +
                '</summary>' +
                '<div class="ft-charts-grid ft-charts-grid--secondary">' +
                  chartCard('hourlyCarbs', 'Carbs per hour', 'each bar vs your ' + p.targets.carbsGH + ' g/h target',
                    'Carbs-per-hour bar chart targeting ' + p.targets.carbsGH + ' grams per hour, capped at the ' + (p.targets.gutCeilingGH || p.targets.carbsGH) + ' g/h gut tier ceiling.') +
                  /* SCI-P1-8: Carb deficit chart \u2014 high-actionability "you went into deficit at X" visual */
                  chartCard('carbDeficit', 'Carb deficit', 'target minus actual \u00b7 above zero = behind schedule',
                    'Cumulative carb deficit over time. Positive numbers mean the athlete is behind the target intake schedule and at risk of bonking.') +
                  chartCard('bonkRisk', 'Bonk risk index', 'composite score 0\u2013100 \u00b7 above 70 is the bonk zone',
                    'Composite bonk risk score from 0 to 100. Forty percent glycogen depletion, thirty percent carb intake gap, twenty percent intensity, ten percent hydration debt.') +
                  chartCard('glycogen', 'Glycogen reserve', 'estimated muscle store remaining \u00b7 lower = bonk risk',
                    'Glycogen reserve curve from 100 percent at start, declining as the session burns muscle glycogen offset by external carb intake.') +
                  (p.meta && p.meta.isCyclistish ? chartCard('wbal', 'Anaerobic reserve', 'simplified estimate \u00b7 starts at ~' + (p.meta.wbalInitialKJ || 20) + ' kJ',
                    'W prime balance, the anaerobic work reserve from Skiba 2012. Depletes above critical power. Adequate fueling reduces drain by up to fifty percent.') : '') +
                  chartCard('caffeine', 'Caffeine plasma', 'rising + decaying mg in bloodstream \u00b7 ISSN performance band',
                    'Caffeine plasma curve modelling rises at each caffeine event and decay at a 5 hour half life. Total plan dose ' + p.totals.caffeineMg + ' milligrams.') +
                  chartCard('fluid', 'Fluid balance', 'intake vs estimated sweat loss',
                    'Fluid balance: ' + p.totals.fluidMl + ' millilitres planned intake versus estimated sweat loss at ' + p.targets.sweatRate + ' millilitres per hour.') +
                  chartCard('sodium', 'Sodium balance', 'intake vs estimated sweat loss',
                    'Sodium balance: ' + p.totals.sodiumMg + ' milligrams planned intake versus estimated sweat loss.') +
                  /* V7-15: Perf Lab booking CTA fills the grid cell next to Sodium balance.
                     Links to the real "Ultimate Performance+ | SIGR LAB" package (£249.99). */
                  perfLabCard() +
                '</div>' +
              '</details>' +
            '</div>' +
  
            /* Credibility strip */
            /* SCI-P0-4: Sources block — permanent, visible, full citation list.
               Audit said the credibility claim of "10 peer-reviewed sources" was
               undermined by the sources living behind a modal. Now they're on the page. */
            '<div class="ft-block ft-block-sources">' +
              '<div class="ft-eyebrow">06 · Sources</div>' +
              '<h3 class="ft-h2" style="margin-top:8px">The 10 peer-reviewed papers behind every number.</h3>' +
              '<ol class="ft-sources-list">' +
                Object.keys(DATA.CITATIONS).map(function (k) {
                  var c = DATA.CITATIONS[k];
                  return '<li class="ft-source" id="ft-src-' + k + '">' +
                    '<div class="ft-source-num">[' + k + ']</div>' +
                    '<div class="ft-source-body">' +
                      '<div class="ft-source-tag">' + c.tag + '</div>' +
                      '<div class="ft-source-cite">' +
                        '<strong>' + c.authors + '</strong> (' + c.year + '). ' + c.title + '. ' +
                        '<em>' + c.journal + '</em>' + (c.vol ? ', ' + c.vol : '') + (c.pages ? ', ' + c.pages : '') + '.' +
                      '</div>' +
                      (c.url ? '<a class="ft-source-link" href="' + c.url + '" target="_blank" rel="noopener noreferrer">View on publisher →</a>' : '') +
                    '</div>' +
                  '</li>';
                }).join('') +
              '</ol>' +
            '</div>' +
  
            /* "Built on the science" cell removed \u2014 the Sources block above ("The 10
               peer-reviewed papers behind every number") now carries that message,
               so it was duplicative. Performance Lab + UK-made cells retained. */
            '<div class="ft-block-cred ft-cred ft-cred--2col">' +
              '<div class="ft-cred-cell"><div class="ft-eyebrow" style="margin-bottom:8px">Want exact numbers?</div><strong>STYRKR Performance Lab</strong> offers in-person sweat-sodium testing for athletes who want lab-precise plans. <a href="#" data-action="open-perf-lab" style="text-decoration:underline;color:var(--ft-accent)">Find out more \u2192</a></div>' +
              '<div class="ft-cred-cell"><div class="ft-eyebrow" style="margin-bottom:8px">UK-made fuel</div>STYRKR products are formulated and produced in the UK, using a 1:0.8 maltodextrin\u2013fructose ratio for high-rate dual-carb absorption.</div>' +
            '</div>' +
          '</div>' +
  
          /* Sticky mobile CTA */
          '<div class="ft-cta-sticky">' +
            '<div class="ft-cta-sticky-status"><span class="ft-cta-sticky-dot"></span>Plan ready \u00b7 ' + money(p.bundleTotal) + '</div>' +
            '<button class="ft-btn ft-btn-primary" data-action="cart" style="padding:10px 18px">Add box \u2192</button>' +
          '</div>' +
        '</section>';
    }
  
    function targetCell(num, unit, label, cite) {
      return '<div class="ft-target">' +
        '<div class="ft-target-num" data-counter="' + num + '">0</div>' +
        '<div class="ft-target-unit">' + unit + ' \u00b7 ' + label + '</div>' +
        '<div class="ft-target-tag">' + cite + '</div>' +
      '</div>';
    }
  
    function chartCard(id, title, sub, srSummary, footer) {
      var summary = srSummary || (title + ' — ' + sub);
      return '<figure class="ft-chart-card" role="figure" aria-label="' + summary.replace(/"/g, '&quot;') + '">' +
        '<figcaption class="ft-chart-cap">' +
          '<div class="ft-chart-title">' + title + '</div>' +
          '<div class="ft-chart-sub">' + sub + '</div>' +
        '</figcaption>' +
        '<div class="ft-chart" id="ft-chart-' + id + '" aria-hidden="true"></div>' +
        (footer || '') +
      '</figure>';
    }
    /* V7-15: Performance Lab booking CTA, styled as a chart-card so it sits cleanly
       in the secondary grid next to Sodium balance. Links to the real "Ultimate
       Performance+ | SIGR LAB" package (verified live product, £249.99). The plan's
       estimates end here — this is where an athlete who wants lab-exact numbers books. */
    function perfLabCard() {
      // Links to the SIGR Performance Lab page's Packages section (all tiers), not a
      // single SKU PDP — #sigr-packages is the section anchor on that page.
      var url = '/pages/sigr-human-performance-lab#sigr-packages';
      return '<a class="ft-chart-card ft-lab-cta" href="' + url + '">' +
        '<div class="ft-lab-cta-eyebrow">STYRKR Performance Lab</div>' +
        '<div class="ft-lab-cta-title">These are estimates.<br>Get your real numbers.</div>' +
        '<div class="ft-lab-cta-body">In-person lactate, VO₂, sweat-sodium and carb-oxidation testing — then a personalised fueling strategy built on your data.</div>' +
        '<div class="ft-lab-cta-foot">' +
          '<span class="ft-lab-cta-btn">View Performance Lab packages →</span>' +
          '<span class="ft-lab-cta-price">from £169.99</span>' +
        '</div>' +
      '</a>';
    }
    // Product-type key — visual legend matching the carb-balance chart markers.
    function carbBalanceKey() {
      return '<div class="ft-chart-key" aria-hidden="true">' +
        '<span class="ft-key-item"><span class="ft-key-dot ft-key-dot--mix"></span>MIX (drink)</span>' +
        '<span class="ft-key-item"><span class="ft-key-dot ft-key-dot--gel"></span>GEL</span>' +
        '<span class="ft-key-item"><span class="ft-key-dot ft-key-dot--bar"></span>BAR</span>' +
        '<span class="ft-key-item"><span class="ft-key-dot ft-key-dot--slt"></span>SLT+ (electrolyte)</span>' +
      '</div>';
    }
  
    function renderTimeline(p) {
      var dur = p.input.durationMin;
      var preStart = (p.targets && p.targets.preStartMin) || 0;
      var range = dur - preStart;
      function pctOf(timeMin) { return ((timeMin - preStart) / range) * 100; }
      function fmt(timeMin) {
        var neg = timeMin < 0;
        var abs = Math.abs(timeMin);
        var hh = Math.floor(abs / 60), mm = abs % 60;
        return (neg ? '\u2212' : '') + hh + ':' + (mm < 10 ? '0' + mm : mm);
      }
      var ticks = [];
      var tickInterval = dur > 480 ? 120 : dur > 240 ? 60 : 30;
      // Pre-race tick (only if there's a pre-race window).
      // We render only the START divider here — the pre-race time is conveyed by the
      // event's own "PRE" tag. Avoids the duplicate "-0:30" overlap.
      if (preStart < 0) {
        ticks.push('<div class="ft-timeline-tick is-pre" style="left:' + pctOf(preStart) + '%"></div>');
        ticks.push('<div class="ft-timeline-divider" style="left:' + pctOf(0) + '%" aria-label="race start"></div>' +
                   '<div class="ft-timeline-tick-label is-divider" style="left:' + pctOf(0) + '%">START</div>');
      }
      // If we already drew a START divider at t=0, skip the redundant "0:00" tick.
      var firstTick = (preStart < 0) ? tickInterval : 0;
      for (var t = firstTick; t <= dur; t += tickInterval) {
        ticks.push('<div class="ft-timeline-tick" style="left:' + pctOf(t) + '%"></div>' +
                   '<div class="ft-timeline-tick-label" style="left:' + pctOf(t) + '%">' + fmt(t) + '</div>');
      }
  
      // ── CLUSTER STAGGER ──
      // When events fall close on the axis, labels stack into rows 0–4 so every
      // product name stays visible without hover. Horizontal scroll handles width.
      var CLUSTER_GAP_PCT = 16;       // ~9.5 min on a 1h timeline · ~38 min on a 4h
      var rowsActive = [];            // [{ pct, row }] — most recent event per row
      var rowAssign = new Array(p.events.length);
      p.events.forEach(function (ev, idx) {
        var pct = pctOf(ev.timeMin);
        // Assign a stagger row to every event so close clusters don't overlap.
        var assigned = -1;
        for (var r = 0; r < 5; r++) {
          var last = rowsActive[r];
          if (last == null || (pct - last) >= CLUSTER_GAP_PCT) { assigned = r; break; }
        }
        if (assigned === -1) assigned = 0;        // saturate at row 0 if more than 5 clustered
        rowsActive[assigned] = pct;
        rowAssign[idx] = assigned;
      });
  
      var events = p.events.map(function (ev, idx) {
        var pct = pctOf(ev.timeMin);
        var isCaf = ev.product.caffeinated;
        var isPre = ev.timeMin < 0;
        var timeStr = fmt(ev.timeMin);
        var tooltip = ev.product.title + ' · +' + ev.carbs + 'g carbs at ' + timeStr;
        // Edge-aware tooltip flagging — prevents overflow at left/right ends of the axis.
        var nearStart = pct < 12;
        var nearEnd = pct > 88;
        var row = rowAssign[idx] || 0;
        return '<div class="ft-timeline-event' +
          (isCaf ? ' is-caf' : '') +
          (isPre ? ' is-pre' : '') +
          (nearStart ? ' is-near-start' : '') +
          (nearEnd ? ' is-near-end' : '') + '"' +
          ' style="left:' + pct + '%"' +
          ' data-row="' + row + '"' +
          ' data-tip="' + tooltip.replace(/"/g, '&quot;') + '"' +
          ' tabindex="0" role="button" aria-label="' + tooltip + '">' +
          '<div class="ft-timeline-event-dot"></div>' +
          '<div class="ft-timeline-event-pop">' +
            '<div class="ft-timeline-event-product">' + ev.product.shortTitle + '</div>' +
            '<div class="ft-timeline-event-label">' + timeStr + ' · +' + ev.carbs + 'g</div>' +
          '</div>' +
        '</div>';
      });
  
      // Mobile: enforce minimum width per event so timeline is scrollable, not squished
      var minWidthPx = Math.max(720, p.events.length * 90);
  
      // \u2500\u2500 VERTICAL LIST (mobile) \u2500\u2500
      // The horizontal scroll-axis works on desktop but breaks on phones: the hover
      // tooltips clip against the scroll container, staggered labels crop, and many
      // dots are impossible to tap accurately. On mobile we render a clean vertical
      // schedule instead \u2014 one tappable row per fueling moment, every detail visible,
      // no scroll, no clipping. CSS toggles which one shows per breakpoint.
      var vlist = p.events.map(function (ev) {
        var isCaf = ev.product.caffeinated;
        var isPre = ev.timeMin < 0;
        var timeStr = fmt(ev.timeMin);
        var parts = [];
        if (ev.carbs > 0)    parts.push('+' + ev.carbs + 'g carbs');
        if (ev.fluid > 0)    parts.push(ev.fluid + 'ml');
        if (ev.sodium > 0)   parts.push(ev.sodium + 'mg Na');
        if (ev.caffeine > 0) parts.push(ev.caffeine + 'mg caf');
        var meta = parts.join(' \u00b7 ') || 'Hydration top-up';
        return '<li class="ft-tl-row' + (isCaf ? ' is-caf' : '') + (isPre ? ' is-pre' : '') + '">' +
          '<div class="ft-tl-time">' + (isPre ? 'PRE' : timeStr) + '</div>' +
          '<div class="ft-tl-marker"><span class="ft-tl-dot"></span></div>' +
          '<div class="ft-tl-body">' +
            '<div class="ft-tl-product">' + ev.product.shortTitle + (isCaf ? ' <span class="ft-tl-caf">caf</span>' : '') + '</div>' +
            '<div class="ft-tl-meta">' + meta + '</div>' +
          '</div>' +
        '</li>';
      }).join('');
  
      return '<div class="ft-timeline-scroll" aria-hidden="false">' +
        '<div class="ft-timeline-wrap" style="min-width:' + minWidthPx + 'px">' +
          '<div class="ft-timeline-axis">' +
            ticks.join('') +
            events.join('') +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="ft-timeline-hint">Swipe to scan the full timeline</div>' +
      '<ol class="ft-timeline-vlist">' + vlist + '</ol>' +
      '<div class="ft-timeline-legend ft-mute">' + p.events.length + ' fueling moments, in order \u00b7 ' +
        p.totals.carbsG + 'g carbs total.' +
      '</div>';
    }
  
    function navButtons(showSubmit) {
      return '<div class="ft-nav">' +
        '<button class="ft-btn ft-btn-ghost" data-action="back">\u2190 Back</button>' +
        '<button class="ft-btn ft-btn-primary" data-action="next" id="ft-next-btn">' + (showSubmit ? 'Build my plan \u2192' : 'Continue \u2192') + '</button>' +
      '</div>';
    }
  
    /* ─────────────────────────────────────────────
       ROUTING
    ───────────────────────────────────────────── */
    function nextScreen() {
      var idx = SCREENS.indexOf(state.currentScreen);
      state.currentScreen = SCREENS[idx + 1] || state.currentScreen;
  
      if (state.currentScreen === 'gate' && !state.plan) {
        try {
          state.plan = DATA.generatePlan(buildPlanInput());
        } catch (err) {
          console.error('[fuel-tool] plan generation failed:', err);
          state.plan = null;
        }
      }
      render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  
    function prevScreen() {
      var idx = SCREENS.indexOf(state.currentScreen);
      state.currentScreen = SCREENS[Math.max(0, idx - 1)] || 'welcome';
      render();
    }
  
    function buildPlanInput() {
      var weightKg = state.weightUnit === 'lb' ? Math.round(state.weightKg * 0.453592) : state.weightKg;
      return {
        mode: state.mode,
        sessionType: state.sessionType,
        sport: state.sport,
        durationMin: state.durationMin,
        intensity: state.intensity || 'steady',
        weightKg: weightKg,
        caffeine: state.caffeine || 'half',
        products: state.products || [],
        gutTier: state.gutTier || 'experienced',
        sweatRateMlH: state.sweatRateMlH ? +state.sweatRateMlH : null,
        sodiumTier: state.sodiumTier,
        ftpW: state.ftpW ? +state.ftpW : null,
        thresholdPaceMinKm: state.thresholdPaceMinKm,
        goal: state.goal || 'pb',
        dietary: state.dietary,
        environment: state.environment || 'mild',  // SCI-P0-3
        flavour: state.flavour
      };
    }
  
    function canAdvance() {
      switch (state.currentScreen) {
        case 'welcome':   return !!state.mode;
        case 'sport':     return !!state.sport;
        case 'session':   return !!state.sessionType;
        case 'duration':  return state.durationMin > 0;
        case 'intensity': return !!state.intensity;
        case 'weight':    return state.weightKg >= 30 && state.weightKg <= 200;
        case 'caffeine':  return !!state.caffeine;
        case 'products':  return (state.products || []).some(function (p) { return ['MIX60', 'MIX90', 'MIX_PLUS', 'GEL50', 'GEL30', 'BAR50', 'BAR30'].indexOf(p) !== -1; });
        case 'gut':       return !!state.gutTier;
        default:          return true;
      }
    }
  
    /* ─────────────────────────────────────────────
       RENDER
    ───────────────────────────────────────────── */
    function render() {
      var root = el('ft-stage');
      if (!root) return;
  
      var screen = state.currentScreen;
      var html = '';
      if (screen === 'welcome')   html = renderWelcome();
      else if (screen === 'sport')     html = renderSport();
      else if (screen === 'session')   html = renderSession();
      else if (screen === 'duration')  html = renderDuration();
      else if (screen === 'intensity') html = renderIntensity();
      else if (screen === 'weight')    html = renderWeight();
      else if (screen === 'caffeine')  html = renderCaffeine();
      else if (screen === 'products')  html = renderProducts();
      else if (screen === 'gut')       html = renderGut();
      else if (screen === 'gate')      html = renderGate();
      else if (screen === 'result')    html = renderResult();
  
      root.innerHTML = html;
      updateProgress();
      updateSelections();
      bindEvents();
      // Save after every screen transition. Covers nav (next/prev) and any
      // re-render triggered by state changes — a single save site keeps things
      // simple and guarantees we never miss an update.
      persistState();
  
      if (screen === 'result') {
        animateCounters();
        // Render the 2 primary charts immediately. Secondary charts lazy-mount the first
        // time the user opens the "See full physiology" expander.
        var charts = window.STYRKR_FUEL_V7_CHARTS;
        if (charts) {
          (charts.renderPrimary || charts.render)(state.plan);
        }
        var moreEl = el('ft-charts-more');
        if (moreEl && charts && charts.renderSecondary) {
          var rendered = false;
          moreEl.addEventListener('toggle', function () {
            if (!moreEl.open || rendered) return;
            rendered = true;
            charts.renderSecondary(state.plan);
          });
        }
        // P1-9 + V4-6: tap-to-reveal + focus-suppression on timeline dots.
        //  - Tap a dot → it becomes .is-active, axis gets .has-focus, siblings get .is-faded
        //  - Hover a dot → same focus-suppression while pointer is over it
        //  - Tap outside or move pointer away → everything clears
        var timelineAxis = document.querySelector('.ft-timeline-axis');
        var timelineDots = qsa('.ft-timeline-event');
        function focusDot(targetDot) {
          if (!timelineAxis) return;
          timelineAxis.classList.add('has-focus');
          timelineDots.forEach(function (d) {
            if (d === targetDot) d.classList.remove('is-faded');
            else d.classList.add('is-faded');
          });
        }
        function clearFocus() {
          if (!timelineAxis) return;
          timelineAxis.classList.remove('has-focus');
          timelineDots.forEach(function (d) {
            d.classList.remove('is-faded');
            d.classList.remove('is-active');
          });
        }
        if (timelineDots.length && timelineAxis) {
          timelineDots.forEach(function (dot) {
            dot.addEventListener('click', function (e) {
              e.stopPropagation();
              var wasActive = dot.classList.contains('is-active');
              // Reset all then re-apply if not already
              timelineDots.forEach(function (d) { d.classList.remove('is-active'); });
              if (!wasActive) { dot.classList.add('is-active'); focusDot(dot); }
              else { clearFocus(); }
            });
            dot.addEventListener('mouseenter', function () { focusDot(dot); });
            dot.addEventListener('focus', function () { focusDot(dot); });
          });
          // Mouse leaves the whole timeline — clear hover-driven focus
          timelineAxis.addEventListener('mouseleave', function () {
            // Don't kill tap-active focus on mouseleave; only clear if nothing tapped
            var anyActive = timelineDots.some(function (d) { return d.classList.contains('is-active'); });
            if (!anyActive) clearFocus();
          });
          // Click outside the timeline closes the open tap
          document.addEventListener('click', function () { clearFocus(); });
        }
      }
  
      // Disable next if not ready
      var nextBtn = el('ft-next-btn');
      if (nextBtn) nextBtn.disabled = !canAdvance();
    }
  
    function updateProgress() {
      var bar = el('ft-progress-bar');
      var stepIndicator = el('ft-step-indicator');
      var idx = SCREENS.indexOf(state.currentScreen);
      var pct = state.currentScreen === 'welcome' ? 0
             : state.currentScreen === 'result' ? 100
             : Math.round((idx / (SCREENS.length - 2)) * 100);
      if (bar) bar.style.width = pct + '%';
      if (stepIndicator) {
        if (state.currentScreen === 'welcome') {
          stepIndicator.style.display = 'none';
        } else {
          stepIndicator.style.display = '';
          var coreIdx = ['sport', 'session', 'duration', 'intensity', 'weight', 'caffeine', 'products', 'gut'].indexOf(state.currentScreen);
          var n = coreIdx >= 0 ? (coreIdx + 1) : (state.currentScreen === 'gate' ? 8 : state.currentScreen === 'result' ? 9 : 0);
          stepIndicator.innerHTML = '<span class="ft-step-current">' + (n < 10 ? '0' + n : n) + '</span> / 09';
        }
      }
    }
  
    function updateSelections() {
      qsa('.ft-opt[data-q]').forEach(function (b) {
        var q = b.getAttribute('data-q');
        var v = b.getAttribute('data-val');
        if (state[q] === v) b.classList.add('is-selected');
        else b.classList.remove('is-selected');
      });
    }
  
    function animateCounters() {
      qsa('[data-counter]').forEach(function (el) {
        var target = +el.getAttribute('data-counter');
        var start = 0;
        var dur = 1100;
        var t0 = performance.now();
        function step(now) {
          var p = Math.min(1, (now - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(start + (target - start) * eased);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
  
    /* ─────────────────────────────────────────────
       EVENT BINDING
    ───────────────────────────────────────────── */
    function bindEvents() {
      qsa('.ft-mode-card').forEach(function (b) {
        b.addEventListener('click', function () {
          state.mode = b.getAttribute('data-mode');
          trackKlaviyo('Started Fuel Tool', { mode: state.mode });
          nextScreen();
        });
      });
  
      qsa('.ft-opt[data-q]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = b.getAttribute('data-q');
          var v = b.getAttribute('data-val');
          state[q] = v;
          updateSelections();
          var nextBtn = el('ft-next-btn');
          if (nextBtn) nextBtn.disabled = !canAdvance();
        });
      });
  
      // V7-20: product picker is MULTI-select — toggle membership in state.products
      // (distinct from the single-select .ft-opt[data-q] cards above).
      qsa('[data-product]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          var k = b.getAttribute('data-product');
          var arr = state.products ? state.products.slice() : [];
          var idx = arr.indexOf(k);
          if (idx === -1) arr.push(k); else arr.splice(idx, 1);
          state.products = arr;
          var on = arr.indexOf(k) !== -1;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          var nextBtn = el('ft-next-btn');
          if (nextBtn) nextBtn.disabled = !canAdvance();
        });
      });
  
      var dur = el('ft-dur-slider');
      if (dur) {
        dur.addEventListener('input', function () {
          state.durationMin = +dur.value;
          var hrs = Math.floor(state.durationMin / 60);
          var mins = state.durationMin % 60;
          el('ft-dur-readout').innerHTML = hrs + '<span style="font-size:0.5em;color:var(--ft-mute);font-weight:400">h</span> ' + (mins < 10 ? '0' + mins : mins) + '<span style="font-size:0.5em;color:var(--ft-mute);font-weight:400">m</span>';
          var min = +dur.min, max = +dur.max;
          dur.style.setProperty('--ft-fill', (((state.durationMin - min) / (max - min)) * 100) + '%');
        });
      }
  
      var weight = el('ft-weight-input');
      if (weight) {
        weight.addEventListener('input', function () {
          state.weightKg = +weight.value;
          var nextBtn = el('ft-next-btn');
          if (nextBtn) nextBtn.disabled = !canAdvance();
        });
      }
      // +/- steppers — adjust by ±1, clamp to min/max, fire input event so listeners update
      qsa('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = el('ft-weight-input');
          if (!input) return;
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          var min = +(input.getAttribute('min') || 30);
          var max = +(input.getAttribute('max') || 200);
          var next = Math.max(min, Math.min(max, (+input.value || 0) + step));
          input.value = next;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      qsa('[data-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.weightUnit = b.getAttribute('data-unit');
          qsa('[data-unit]').forEach(function (x) {
            x.classList.remove('is-active');
            x.setAttribute('aria-pressed', 'false');
          });
          b.classList.add('is-active');
          b.setAttribute('aria-pressed', 'true');
        });
      });
  
      qsa('[data-bind]').forEach(function (input) {
        var key = input.getAttribute('data-bind');
        input.addEventListener('input', function () {
          state[key] = input.type === 'checkbox' ? input.checked : input.value;
        });
      });
  
      qsa('[data-action="next"]').forEach(function (b) {
        b.addEventListener('click', function () { if (canAdvance()) nextScreen(); });
      });
      qsa('[data-action="back"]').forEach(function (b) {
        b.addEventListener('click', prevScreen);
      });
      qsa('[data-action="toggle-refine"]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.refineOpen = !state.refineOpen;
          var panel = el('ft-refine');
          if (panel) panel.classList.toggle('is-open', state.refineOpen);
          // iPhone-16 audit fix: keep the TOGGLE in sync with the panel — chevron
          // rotation, aria-expanded, and label all key off `.is-open`/state. Previously
          // only the panel updated, so the chevron never rotated and the label stayed
          // "Tap to refine" even when open.
          b.classList.toggle('is-open', state.refineOpen);
          b.setAttribute('aria-expanded', state.refineOpen ? 'true' : 'false');
          var label = b.querySelector('.ft-refine-toggle-label');
          if (label) label.textContent = state.refineOpen ? 'Hide refinements' : 'Tap to refine your plan';
        });
      });
      qsa('[data-action="open-citations"]').forEach(function (b) {
        b.addEventListener('click', function () {
          var m = el('ft-modal-citations');
          if (m) m.classList.add('is-open');
        });
      });
      qsa('[data-action="open-perf-lab"]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var m = el('ft-modal-perf-lab');
          if (m) m.classList.add('is-open');
        });
      });
      qsa('[data-action="close-modal"]').forEach(function (b) {
        b.addEventListener('click', function () {
          qsa('.ft-modal').forEach(function (m) { m.classList.remove('is-open'); });
        });
      });
      // Retry / adjust buttons on the plan-failure error state
      qsa('[data-action="retry-plan"]').forEach(function (b) {
        b.addEventListener('click', function () {
          try {
            state.plan = DATA.generatePlan(buildPlanInput());
          } catch (err) { state.plan = null; }
          render();
        });
      });
      qsa('[data-action="back-to-gut"]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.currentScreen = 'gut';
          state.plan = null;
          render();
        });
      });
  
      // V4-13: wire the optional Sex pill buttons. Click toggles state.sex.
      // Clicking the same button again clears the selection (re-tap to opt out).
      qsa('.ft-sex-opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-sex');
          state.sex = (state.sex === val) ? '' : val;
          qsa('.ft-sex-opt').forEach(function (other) {
            var isMatch = other.getAttribute('data-sex') === state.sex;
            other.classList.toggle('is-active', isMatch);
            other.setAttribute('aria-checked', isMatch ? 'true' : 'false');
          });
          persistState();
        });
      });
  
      var revealBtn = el('ft-reveal');
      if (revealBtn) {
        revealBtn.addEventListener('click', function () {
          var emailInput = el('ft-email');
          var emailError = el('ft-email-error');
          var valid = state.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
          if (!valid) {
            if (emailInput) emailInput.setAttribute('aria-invalid', 'true');
            if (emailError) emailError.textContent = 'Enter a valid email so we can send your plan.';
            if (emailInput) emailInput.focus();
            return;
          }
          if (emailInput) emailInput.removeAttribute('aria-invalid');
          if (emailError) emailError.textContent = '';
          var input = buildPlanInput();
          // Full data-capture: durable profile properties + rich Plan Generated event.
          var payloads = buildKlaviyoPayloads(input, state.plan);
          identifyKlaviyo(payloads.identity);
          trackKlaviyo('Plan Generated', payloads.planEvent);
          state.currentScreen = 'result';
          render();
        });
      }
  
      var cartBtn = el('ft-cart-btn');
      if (cartBtn) {
        cartBtn.addEventListener('click', addBundleToCart);
      }
      qsa('[data-action="cart"]').forEach(function (b) {
        b.addEventListener('click', addBundleToCart);
      });
  
      qsa('[data-png]').forEach(function (b) {
        b.addEventListener('click', function () {
          downloadShareCard(b.getAttribute('data-png'));
        });
      });
      var pdfBtn = el('ft-pdf-btn');
      if (pdfBtn) pdfBtn.addEventListener('click', function () { window.print(); });
    }
  
    /* ─────────────────────────────────────────────
       CART INTEGRATION
    ───────────────────────────────────────────── */
    function addBundleToCart() {
      var p = state.plan;
      if (!p) return;
      var items = p.bundle.map(function (b) {
        return { id: b.product.variantId, quantity: b.boxes, title: b.product.shortTitle };
      });
      var cartBtn = el('ft-cart-btn');
      var statusEl = el('ft-cart-status');
      var originalLabel = cartBtn ? cartBtn.textContent : '';
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.setAttribute('aria-busy', 'true');
        cartBtn.textContent = 'Adding to cart\u2026';
      }
      if (statusEl) statusEl.textContent = '';
  
      // V7-24: add items ONE AT A TIME. /cart/add.js fails atomically for a
      // multi-item body, so a single sold-out line silently dropped the entire
      // bundle (that was the "add to cart not working" bug). Adding individually
      // means every in-stock box still lands, and we can name what didn't.
      var added = [], failed = [];
      function addOne(idx) {
        if (idx >= items.length) return finish();
        var it = items[idx];
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: it.id, quantity: it.quantity }] })
        }).then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, body: body }; });
        }).then(function (res) {
          if (res.ok) added.push(it); else failed.push(it);
        }).catch(function () {
          failed.push(it);
        }).then(function () {
          return addOne(idx + 1);
        });
      }
      function finish() {
        if (added.length === 0) {
          if (cartBtn) {
            cartBtn.disabled = false;
            cartBtn.removeAttribute('aria-busy');
            cartBtn.textContent = originalLabel || 'Add box to cart \u2192';
          }
          if (statusEl) statusEl.textContent = 'These products are temporarily unavailable \u2014 please try again shortly.';
          console.error('[fuel-tool] cart add failed for all items:', failed.map(function (f) { return f.title; }));
          return;
        }
        trackKlaviyo('Plan Added to Cart', {
          plan_id: p.planId,
          bundle_total: p.bundleTotal,
          skus: added.map(function (a) { return a.title; }).join(', '),
          items_added: added.length,
          items_failed: failed.length
        });
        if (failed.length && statusEl) {
          statusEl.textContent = 'Added ' + added.length + ' of ' + items.length + ' \u2014 ' +
            failed.map(function (f) { return f.title; }).join(', ') + ' out of stock. Taking you to your cart\u2026';
          window.setTimeout(function () { window.location.href = '/cart'; }, 1500);
        } else {
          window.location.href = '/cart';
        }
      }
      addOne(0);
    }
  
    /* ─────────────────────────────────────────────
       PNG EXPORTS — two formats, both white-on-black-and-lime
         1. card  → A4-portrait race-day reference (1080x1920)
         2. story → Instagram story (1080x1920, brand-led)
       Uses html2canvas (CDN-loaded on first click).
    ───────────────────────────────────────────── */
    function downloadShareCard(format) {
      format = format || 'card';
      var btn = qs('[data-png="' + format + '"]');
      var btnLabel = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Generating\u2026';
  
      function doRender() {
        var node = format === 'story' ? buildStoryHtml() : buildCardHtml();
        document.body.appendChild(node);
        window.html2canvas(node, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
          logging: false
        }).then(function (canvas) {
          var link = document.createElement('a');
          link.download = 'styrkr-fuel-' + format + '-' + state.plan.planId + '.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
          document.body.removeChild(node);
          if (btn) btn.textContent = btnLabel;
          trackKlaviyo('Plan PNG Downloaded', { plan_id: state.plan.planId, format: format });
        }).catch(function (err) {
          console.error('[fuel-tool] PNG render failed:', err);
          if (btn) btn.textContent = 'Error \u2014 try again';
          try { document.body.removeChild(node); } catch (e) {}
        });
      }
  
      if (window.html2canvas) doRender();
      else {
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        s.onload = doRender;
        document.head.appendChild(s);
      }
    }
  
    /* RACE-DAY CARD — white canvas, black type, lime accents.
       Designed to print A4 / save to phone home screen. */
    function buildCardHtml() {
      var p = state.plan;
      var summary = (p.input.durationMin / 60).toFixed(p.input.durationMin % 60 === 0 ? 0 : 1) + 'h \u00b7 ' +
                    (DATA.DISCIPLINES[p.input.sport] || {}).label + ' \u00b7 ' +
                    (DATA.INTENSITY[p.input.intensity] || {}).label;
      var name = state.firstName || 'ATHLETE';
      var node = document.createElement('div');
      node.style.cssText = "position:fixed;top:-9999px;left:0;width:1080px;height:1528px;background:#ffffff;color:#0a0a0a;font-family:'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,Arial,sans-serif;padding:96px 80px;box-sizing:border-box;";
      var brandRow =
        '<div style="display:flex;justify-content:space-between;align-items:center;font-family:ui-monospace,SF Mono,Menlo,monospace;font-size:14px;letter-spacing:0.18em;font-weight:700">' +
          '<span>STYRKR \u00b7 FUEL PLAN</span>' +
          '<span style="color:#0a0a0a;font-weight:500;letter-spacing:0.1em">' + p.planId + '</span>' +
        '</div>';
      var heading =
        '<div style="margin-top:48px;font-family:ui-monospace,monospace;font-size:12px;letter-spacing:0.16em;color:rgba(10,10,10,0.55);text-transform:uppercase">For ' + name + '</div>' +
        '<div style="margin-top:8px;font-size:22px;color:#0a0a0a">' + summary + '</div>';
      var stats =
        '<div style="margin-top:64px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:24px;border-top:1px solid rgba(10,10,10,0.15);border-bottom:1px solid rgba(10,10,10,0.15);padding:32px 0">' +
          statBlock(p.targets.carbsGH, 'g/h carbs') +
          statBlock(p.targets.fluidMlH, 'ml/h fluid') +
          statBlock(p.targets.sodiumMgH, 'mg/h sodium') +
        '</div>';
      var timelineLabel =
        '<div style="margin-top:48px;font-family:ui-monospace,monospace;font-size:12px;letter-spacing:0.16em;color:rgba(10,10,10,0.55);text-transform:uppercase">Race-day timeline</div>';
      var timeline = '<div style="margin-top:16px">' +
        p.events.slice(0, 18).map(function (ev) {
          var t = Math.floor(ev.timeMin / 60) + ':' + (ev.timeMin % 60 < 10 ? '0' : '') + (ev.timeMin % 60);
          return '<div style="display:flex;align-items:baseline;justify-content:space-between;padding:14px 0;border-bottom:1px solid rgba(10,10,10,0.08);font-size:18px">' +
            '<span style="font-family:ui-monospace,monospace;color:rgba(10,10,10,0.55);width:80px;letter-spacing:0.04em">' + t + '</span>' +
            '<span style="flex:1;color:#0a0a0a;font-weight:600">' + ev.product.title.replace(/STYRKR\s*\u2014?\s*/i, '') + '</span>' +
            '<span style="color:#0a0a0a;font-family:ui-monospace,monospace;font-weight:600;background:' + brandAccent() + ';padding:4px 10px;border-radius:99px;font-size:14px">+' + ev.carbs + 'g</span>' +
          '</div>';
        }).join('') +
      '</div>';
      var footer =
        '<div style="position:absolute;bottom:64px;left:80px;right:80px;display:flex;justify-content:space-between;font-family:ui-monospace,monospace;font-size:11px;color:rgba(10,10,10,0.5);letter-spacing:0.12em;text-transform:uppercase">' +
          '<span>Built on the science</span>' +
          '<span>styrkr.com/pages/fuel-tool</span>' +
        '</div>';
      node.innerHTML = brandRow + heading + stats + timelineLabel + timeline + footer;
      return node;
    }
  
    function statBlock(num, unit) {
      return '<div>' +
        '<div style="font-size:84px;font-weight:700;line-height:0.95;letter-spacing:-0.03em;color:#0a0a0a;font-feature-settings:\'tnum\' 1">' + num + '</div>' +
        '<div style="font-family:ui-monospace,monospace;font-size:11px;letter-spacing:0.14em;color:rgba(10,10,10,0.55);text-transform:uppercase;margin-top:8px">' + unit + '</div>' +
      '</div>';
    }
  
    /* INSTAGRAM STORY — 1080x1920, brand-led, social-shareable.
       White canvas, black wordmark, lime accent block, generous padding,
       subtle outer border for depth. */
    function buildStoryHtml() {
      var p = state.plan;
      var name = (state.firstName || 'I').toUpperCase();
      var sport = (DATA.DISCIPLINES[p.input.sport] || {}).label || '';
      var dur = (p.input.durationMin / 60).toFixed(p.input.durationMin % 60 === 0 ? 0 : 1);
      var node = document.createElement('div');
      node.style.cssText = "position:fixed;top:-9999px;left:0;width:1080px;height:1920px;background:#ffffff;color:#0a0a0a;font-family:'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,Arial,sans-serif;padding:64px;box-sizing:border-box;";
      node.innerHTML =
        // Outer border frame
        '<div style="height:100%;border:1px solid rgba(10,10,10,0.15);border-radius:24px;padding:80px 72px;display:flex;flex-direction:column;justify-content:space-between;box-sizing:border-box;position:relative">' +
          // Top: wordmark
          '<div>' +
            '<div style="font-family:Helvetica Neue,Helvetica,-apple-system,BlinkMacSystemFont,Arial,sans-serif;font-weight:800;font-size:48px;letter-spacing:-0.02em;color:#0a0a0a">STYRKR</div>' +
            '<div style="margin-top:8px;font-family:ui-monospace,monospace;font-size:14px;letter-spacing:0.18em;color:rgba(10,10,10,0.55);text-transform:uppercase">Fuel Tool</div>' +
          '</div>' +
          // Middle: hero stat
          '<div style="text-align:left">' +
            '<div style="font-family:ui-monospace,monospace;font-size:14px;letter-spacing:0.18em;color:rgba(10,10,10,0.55);text-transform:uppercase">' + name + '\u2019S PLAN</div>' +
            '<div style="margin-top:24px;font-size:240px;font-weight:800;line-height:0.9;letter-spacing:-0.05em;color:#0a0a0a;font-feature-settings:\'tnum\' 1">' +
              p.targets.carbsGH +
              '<span style="font-size:80px;letter-spacing:-0.02em;color:#0a0a0a">g/h</span>' +
            '</div>' +
            '<div style="margin-top:8px;font-size:32px;color:rgba(10,10,10,0.7);font-weight:500;letter-spacing:-0.01em">carbs across ' + dur + ' hours of ' + sport.toLowerCase() + '</div>' +
            // Lime stat block
            '<div style="margin-top:56px;display:inline-block;padding:24px 32px;background:' + brandAccent() + ';border-radius:16px">' +
              '<div style="display:flex;gap:48px">' +
                storyMini(p.targets.fluidMlH, 'ml/h fluid') +
                storyMini(p.targets.sodiumMgH, 'mg/h sodium') +
                storyMini(p.events.length, 'fuel moments') +
              '</div>' +
            '</div>' +
          '</div>' +
          // Bottom: CTA + handle
          '<div>' +
            '<div style="font-size:36px;font-weight:600;color:#0a0a0a;letter-spacing:-0.01em;line-height:1.2;max-width:80%">Built my fueling plan in 3 minutes.</div>' +
            '<div style="margin-top:16px;font-size:24px;color:rgba(10,10,10,0.55)">Build yours \u2192 styrkr.com/pages/fuel-tool</div>' +
            '<div style="margin-top:48px;display:flex;justify-content:space-between;align-items:center;font-family:ui-monospace,monospace;font-size:12px;letter-spacing:0.14em;color:rgba(10,10,10,0.45);text-transform:uppercase;border-top:1px solid rgba(10,10,10,0.12);padding-top:24px">' +
              '<span>Built on the science</span>' +
              '<span>@styrkr</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      return node;
    }
  
    function storyMini(num, unit) {
      return '<div>' +
        '<div style="font-size:48px;font-weight:700;line-height:0.95;letter-spacing:-0.02em;color:#0a0a0a;font-feature-settings:\'tnum\' 1">' + num + '</div>' +
        '<div style="font-family:ui-monospace,monospace;font-size:11px;letter-spacing:0.12em;color:rgba(10,10,10,0.7);text-transform:uppercase;margin-top:4px">' + unit + '</div>' +
      '</div>';
    }
  
    /* ─────────────────────────────────────────────
       MOUNT
    ───────────────────────────────────────────── */
    function mount() {
      var app = qs('.ftv7-app');
      if (!app) return;
  
      // Inject ApexCharts CDN if not already present
      if (!window.ApexCharts) {
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/apexcharts@3.45.0/dist/apexcharts.min.js';
        s.onload = function () { /* available for chart render later */ };
        document.head.appendChild(s);
      }
  
      // Append modal once (Performance Lab)
      var modal = document.createElement('div');
      modal.className = 'ft-modal';
      modal.id = 'ft-modal-perf-lab';
      modal.innerHTML =
        '<div class="ft-modal-card" style="position:relative">' +
          '<button class="ft-modal-close" data-action="close-modal">\u00d7</button>' +
          '<div class="ft-eyebrow">STYRKR Performance Lab</div>' +
          '<h3 class="ft-h2" style="margin-top:8px">Don\u2019t guess your sweat rate \u2014 measure it.</h3>' +
          '<p style="margin-top:16px;color:var(--ft-mute);font-size:14px;line-height:1.55">Get an in-person sweat-sodium and physiology test. We\u2019ll generate an exact, lab-precise plan tuned to your individual physiology.</p>' +
          '<a href="/pages/sigr-human-performance-lab" class="ft-btn ft-btn-primary" style="margin-top:24px">Find out more \u2192</a>' +
        '</div>';
      app.appendChild(modal);
  
      // Citations modal \u2014 3-column grid of paper cards, opens from "Methodology + N citations" button.
      var citeModal = document.createElement('div');
      citeModal.className = 'ft-modal ft-modal--wide';
      citeModal.id = 'ft-modal-citations';
      var cards = Object.keys(DATA.CITATIONS).map(function (n) {
        var c = DATA.CITATIONS[n];
        var hasUrl = !!c.url;
        var open = hasUrl ? '<a class="ft-cite-card" href="' + c.url + '" target="_blank" rel="noopener noreferrer">'
                          : '<div class="ft-cite-card is-static">';
        var close = hasUrl ? '</a>' : '</div>';
        return open +
          '<div class="ft-cite-card-head">' +
            '<span class="ft-cite-card-num">[' + n + ']</span>' +
            '<span class="ft-cite-card-tag">' + (c.tag || '') + '</span>' +
          '</div>' +
          '<div class="ft-cite-card-title">' + c.title + '</div>' +
          '<div class="ft-cite-card-meta">' +
            '<span class="ft-cite-card-authors">' + c.authors + '</span>' +
            '<span class="ft-cite-card-year">' + c.year + '</span>' +
          '</div>' +
          '<div class="ft-cite-card-journal">' + c.journal + ' \u00b7 ' + c.vol + ' \u00b7 ' + c.pages + '</div>' +
          (hasUrl ? '<div class="ft-cite-card-link">Open paper \u2192</div>' : '') +
        close;
      }).join('');
      citeModal.innerHTML =
        '<div class="ft-modal-card ft-modal-card--wide" style="position:relative">' +
          '<button class="ft-modal-close" data-action="close-modal">\u00d7</button>' +
          '<div class="ft-eyebrow">Methodology + references</div>' +
          '<h3 class="ft-h2" style="margin-top:8px">The science behind every number.</h3>' +
          '<p class="ft-cite-intro">Every numeric output in your plan is grounded in published sport-science research. Click any card to open the paper.</p>' +
          '<div class="ft-cite-grid">' + cards + '</div>' +
        '</div>';
      app.appendChild(citeModal);
  
      // Bind close on modal background (any modal)
      [modal, citeModal].forEach(function (m) {
        m.addEventListener('click', function (e) {
          if (e.target === m) m.classList.remove('is-open');
        });
      });
  
      // Restore any saved session BEFORE the first render so the user lands
      // back on their last screen with all inputs intact.
      restoreState();
      render();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }
  
  })(window, document);
  